import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import FieldRow from '../../../../F22/common/FieldRow';
import { r17 as r17Fn } from '../formulas';

const R17Section = ({ data, computed }) => {
  return (
    <SectionContainer title="Recuadro N° 17" subtitle="Base Imponible Régimen Pro PYME (Art. 14 letra D) N° 3 LIR)">
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Ingresos</h4>
        <FieldRow label="Ingresos del giro percibidos" code="1400" sign="(+)" value={r17Fn.ingresosGiroPercibidos(data)} computed />
        <FieldRow label="Ingresos devengados en ejercicios anteriores y percibidos" code="1817" sign="(+)" value={r17Fn.ingresosDevengadosPercibidos(data)} computed />
        <FieldRow label="Rentas de fuente extranjera percibidas" code="1401" sign="(+)" value={r17Fn.rentasFuenteExtranjera(data)} computed />
        <FieldRow label="Ingresos operaciones con empresas relacionadas (14A)" code="1587" sign="(+)" value={r17Fn.ingresosRelacionados14A(data)} computed />
        <FieldRow label="Otros ingresos percibidos o devengados" code="1588" sign="(+)" value={r17Fn.otrosIngresosPercibidos(data)} computed />
        <FieldRow label="Total de ingresos anuales" code="1410" sign="(=)" value={computed.r17?.totalIngresos} computed className="f22-field-subtotal" />
      </div>

      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Egresos</h4>
        <FieldRow label="Existencias, insumos y servicios pagados" code="1409" sign="(-)" value={r17Fn.existenciasPagadas(data)} computed />
        <FieldRow label="Gastos adeudados en ejercicios anteriores y pagados" code="1818" sign="(-)" value={r17Fn.gastosAdeudadosPagados(data)} computed />
        <FieldRow label="Remuneraciones pagadas" code="1411" sign="(-)" value={r17Fn.remuneracionesPagadas(data)} computed />
        <FieldRow label="Honorarios pagados" code="1412" sign="(-)" value={r17Fn.honorariosPagados(data)} computed />
        <FieldRow label="Adquisición bienes activo fijo, pagados" code="1413" sign="(-)" value={r17Fn.activoFijoPagado(data)} computed />
        <FieldRow label="Arriendos pagados" code="1415" sign="(-)" value={r17Fn.arriendosPagados(data)} computed />
        <FieldRow label="Intereses y reajustes pagados" code="1419" sign="(-)" value={r17Fn.interesesPagados(data)} computed />
        <FieldRow label="Partidas art. 21 inc. 1° y 2° LIR pagados" code="1422" sign="(-)" value={r17Fn.partidasArt21(data)} computed />
        <FieldRow label="Otros gastos deducibles" code="1424" sign="(-)" value={r17Fn.otrosGastos(data)} computed />
        <FieldRow label="Total de egresos anuales" code="1430" sign="(=)" value={computed.r17?.totalEgresos} computed className="f22-field-subtotal" />
      </div>

      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Resultado</h4>
        <FieldRow label="Partidas inc. 1° art. 21 LIR (gastos rechazados)" code="1431" sign="(+)" value={r17Fn.gastosRechazadosArt21(data)} computed />
        <FieldRow label="BI antes de incentivo al ahorro" code="1729" sign="(=)" value={computed.r17?.biAntesIncentivo} computed className="f22-field-highlight" />
        <FieldRow label="Incentivo al ahorro art. 14 letra E)" code="1432" sign="(-)" value={r17Fn.incentivoAhorro(data)} computed />
        <FieldRow label="Base Imponible afecta a IDPC" code="1440" sign="(=)" value={computed.r17?.biAfectaIDPC} computed className="f22-field-total" />
      </div>
    </SectionContainer>
  );
};

export default R17Section;
